import { errorMessage } from "../../utils/ErrorMessages";
import Repository from "../../services/repositories/RepositoryFactory";

const share = Repository.service("share");

export default {
  namespaced: true,
  actions: {
    async postShareFile({ rootGetters }, params) {
      try {
        const response = await share.postShareFile(params);
        return response;
      } catch (error) {
        return errorMessage(error.response.data.detail.errors[0][rootGetters.getLanguage]);
      }
    },
  },
};
